import { Component, OnInit, OnDestroy, NgModule, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../blocks';

import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { AlertApprovCycleTransService, AlertApprovCycleTrans } from './alert-approve-cycle-trans.service';
import { UserSessionService } from '../../app-user-session.service';
import { BlocksModule } from '../../blocks/blocks.module';
import { SharedModule } from '../../shared';

@Component({
  selector: 'alert-approve-cycle-trance',
  templateUrl: './alert-approve-cycle-trans.component.html',
})
export class AlertApprovCycleTransComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  alertApprovCycleTransList = [];
  alertSerial: number;
  requestType: string;
  fromEmployeePortal: boolean;
  alertApprovCycleTrans: AlertApprovCycleTrans = <AlertApprovCycleTrans>{};
  @Input() hideSavebtn: boolean

  constructor(
    private _AlertApprovCycleTransService: AlertApprovCycleTransService,
    public translate: TranslateService,
    private _userSessionService: UserSessionService
  ) { }

  ngOnInit() {
    this._userSessionService.subscribeToKey$('RequestAlertSerial').pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {

        if (keys.name == 'RequestAlertSerial' && keys.value) {
          this.alertSerial = +keys.value.alertSerial
          this.requestType = keys.value.requestType
          this.getAlertApprovCycleTrans();

        }
      });
    //_________________________________________________________________________
    this._userSessionService.subscribeToKey$('FromEmployeePortal').pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {

        if (keys.name == 'FromEmployeePortal' && keys.value) {
          this.fromEmployeePortal = keys.value
        }
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  SecLoginRoleId: number;
  getAlertApprovCycleTrans() {
    this.alertApprovCycleTransList = [];
    this._AlertApprovCycleTransService.getAlertApprovCycleTrans(this.alertSerial, this.requestType)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          if (res && res.data && res.data.length > 0) {
            this.alertApprovCycleTransList = res.data;
          }

          if (res && res.data1 && res.data1.length > 0) {
            this.SecLoginRoleId = res.data1[0].roleId
          }
        },
        error => console.log(error),
        () => {
          null
        });
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////
  onClicked(e: number): void {
    switch (e) {
      case 1:
      case -1000:// save
        this.save();
        break;
        break;
    }
  }


  makeDesision(ev, row) {
    if (ev && ev.code) {
      this.alertApprovCycleTrans.serial = row.serial
      this.alertApprovCycleTrans.approveCycleSecLoginId = row.approveCycleSecLoginId
      this.alertApprovCycleTrans.alertConditionSerial = row.alertConditionSerial
      this.alertApprovCycleTrans.requestSerial = row.requestSerial
      this.alertApprovCycleTrans.requestType = row.requestType
      this.alertApprovCycleTrans.status = row.status
      this.alertApprovCycleTrans.requestCycleSecLoginId = row.requestCycleSecLoginId
      this.alertApprovCycleTrans.empCode = row.empCode
      this.alertApprovCycleTrans.nameAr = row.nameAr
      this.alertApprovCycleTrans.nameEn = row.nameEn
      this.alertApprovCycleTrans.insideAlert = row.insideAlert == true ? 1 : 2
      this.alertApprovCycleTrans.mailAlert = row.mailAlert == true ? 1 : 0
      this.alertApprovCycleTrans.smsAlert = row.smsAlert == true ? 1 : 0
      this.alertApprovCycleTrans.whatsAppAlert = row.whatsAppAlert == true ? 1 : 0
      this.alertApprovCycleTrans.mailAddress = row.mailAddress
      this.alertApprovCycleTrans.mobile = row.mobile
      this.alertApprovCycleTrans.refrenceType = row.refrenceType
      this.alertApprovCycleTrans.secLoginRefrence = row.secLoginRefrence
      this.alertApprovCycleTrans.hrAlertApprovalCycleSerial = row.hrAlertApprovalCycleSerial
      //   this.alertApprovCycleTrans.overridelowerlevel        		=row.overridelowerlevel        	
      this.alertApprovCycleTrans.requestEmpCode = row.requestEmpCode
      this.alertApprovCycleTrans.decision = ev.code
    }
  }


  onRowIconClick(actionCode: number, row: AlertApprovCycleTrans) {
    if (actionCode == 7214) {
      row['rowStatus'] = 3
    }
    if (actionCode == 7215) {
      row['rowStatus'] = null
    }

  }


  getCSSClasses(_row: any, index?: number) {
    debugger;
    let cssClasses;
    if (_row && _row.rowStatus == 3) {
      cssClasses = "table-danger";
    }
    else {
      cssClasses = ''
    }
    return cssClasses

  }


  save() {

    this._AlertApprovCycleTransService.updateAlertApprovCycleTrans(this.alertApprovCycleTrans)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
        if (c && c.returnFlag == true) {
          this._userSessionService.setSessionKey('DecisionStatus', this.alertApprovCycleTrans.decision)
          this._userSessionService.closeModalKey('AlertApprovCycleTransComponent', true);
        }
      },
        err => console.log(err)),
      () => {

      };

  }


}

@NgModule({
  imports: [SharedModule, BlocksModule],
  declarations: [AlertApprovCycleTransComponent],
  providers: [AlertApprovCycleTransService],
  exports: [AlertApprovCycleTransComponent]
})
export class AlertApprovCycleTransMod { }


